<iu-prime-fieldset
  [legend]="label"
  [toggleable]="toggleable && !this.isTopEditTab"
  [isSingleRow]="this.data.isSingleRow"
  [isAdditionalInfo]="this.data.isAdditionalInfo ? this.data.isAdditionalInfo : false"
  [(collapsed)]="collapsed"
  [style.display]="isDisplay"
  (openEmitter)="openInNewBlade()"
  [tableName]="this.data ? this.data.TableName : ''"
  [isReadOnly]="this.isReadOnly || this.data.IsReadOnly"
>
  <p-accordion class="p-col-12">
    <ng-template iuDynamicContainer></ng-template>
  </p-accordion>
</iu-prime-fieldset>
